import React from 'react';
import BaseCell from './BaseCell';
import { Select } from '@gulfwinds/ui-components';

const SelectCell = ({
  children, dataItem, field, ...props
}) => (
  <BaseCell {...props} selectable={false}>
    <Select {...props} />
  </BaseCell>
);

export default SelectCell;
